import Delivery from "./delivery";
export class ReportCenter {
    constructor(sdk) {
        this.sdk = sdk;
        this.madSDK = sdk;
        this.delivery = new Delivery(sdk);
    }
}
//# sourceMappingURL=index.js.map